import { Eye, X } from 'lucide-react';
import { useAuth } from '../auth/AuthProvider';

/**
 * Sticky top banner shown to admins while previewing as another user.
 * Indicates read-only state and provides an "Exit preview" action.
 */
export const PreviewBanner = () => {
  const { previewUser, exitPreview } = useAuth();
  if (!previewUser) return null;

  return (
    <div
      role="status"
      className="sticky top-0 z-40 flex items-center gap-3 border-b border-status-warning/40 bg-status-warning/15 px-4 py-2 text-sm text-status-warning"
    >
      <Eye className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="flex-1">
        Previewing as <strong className="font-semibold">{previewUser.displayName}</strong>{' '}
        <span className="text-text-tertiary">({previewUser.email})</span>
        <span className="ml-2 rounded-full bg-status-warning/20 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide">
          Read-only
        </span>
      </span>
      <button
        type="button"
        onClick={exitPreview}
        className="inline-flex items-center gap-1 rounded-md border border-status-warning/40 bg-bg-primary px-3 py-1 text-xs font-medium text-text-primary hover:bg-bg-secondary"
      >
        <X className="h-3 w-3" />
        Exit preview
      </button>
    </div>
  );
};
